import { NgModule } from '@angular/core';

import { PlumeSourceMarkerComponent } from './plume-source-marker.component';

@NgModule({
    exports: [PlumeSourceMarkerComponent],
    declarations: [PlumeSourceMarkerComponent],
})
export class PlumeSourceMarkerModule {}
